import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { fetchAlerts } from "../../actions/integration";
import Pagination from "../Pagination/Pagination";
import { useWebSocket } from '../WebSocket/useWebSocket';


const Inbox = () => {
  const [loading, setLoading] = useState(true);
  const [alerts, setAlerts] = useState([]);
  const [alertCount, setAlertCount] = useState(0);
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.auth?.user?.accessLevel);
  const orgId = useSelector((state) => {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
  });
  const {
    messageUpdate,
    getUpdate
  } = useWebSocket({
    userId: orgId,
    orgId: orgId
  });

  useEffect(() => {
    setTimeout(() => {
      if (orgId) {
        getUpdate({
          userId: orgId,
          organisationId: orgId
        });
      }
    }, [1500])
  }, [orgId])

  const vendorId = sessionStorage.getItem('vendorId');

  const alertResp = useSelector(state => state?.integration?.resalert);

  // useEffect(() => {
  //   setAlerts(messageUpdate?.updates);
  // }, [messageUpdate]);

  useEffect(() => {
    if (messageUpdate?.updates) {
        const filteredMessages = messageUpdate.updates.filter(alert => 
            orgId !== alert?.fromOrganisationId
        );
        setAlerts(filteredMessages);
    }
}, [messageUpdate, orgId]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchAlerts({ organisationId: orgId }, dispatch);
    }
    if (loading && orgId) {
      fetchData();
    }
  }, [dispatch, loading, orgId]);

  let currentTableData = [];
  if (alerts?.length > 0) {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    currentTableData = alerts.slice(firstPageIndex, lastPageIndex);
  }

  return (
    <>
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h2 className="welcome-text">Notifications</h2>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Notifications
                  </li>
                </ol>
              </nav>
            </div>

          </div>
        </div>
        <div className="row clearfix">
          <div className="col-md-12">
            <div className="card">
              <div className="mail-inbox">
                <div className="mobile-left">
                  <Link to="/" className="btn btn-primary toggle-email-nav">
                    <i className="fa fa-bars"></i>
                  </Link>
                </div>

                <div className="body mail-right check-all-parent w-100">
                  <div className="mail-action clearfix m-l-15">
                    <div className="pull-left"></div>
                    <div className="pull-right ml-auto">
                      <div className="pagination-email d-flex">

                      </div>
                    </div>
                  </div>
                  <div className="mail-list">
                    <ul className="list-unstyled">
                      <span className="time welcome-textSmall">Message Received</span>
                      {currentTableData?.map((alert, index) => (
                          <li className="clearfix">
                            <div className="md-left">{(page - 1) * 10 + 1 + index}</div>
                            <Link
                              to={auth == "tprm-question-responder"
                                ? `/questionnaire-details/${alert?.questionFormId}/${alert?.questionId}`
                                : `/review-response/${alert?.questionFormId}/${alert?.questionId}`}
                              className="mail-detail-expand"
                            >
                              <div className="md-right">
                                <p className="sub">
                                  {alert?.fromOrganisation}
                                </p>
                                <p className="dep">
                                  {alert?.messageText}
                                </p>
                              </div>
                            </Link>
                          </li>
                      ))}
                    </ul>
                  </div>

                  {/* <ul className="pagination mb-0">
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Previous
                      </Link>
                    </li>
                    <li className="page-item active">
                      <Link className="page-link" to="#">
                        1
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        2
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        3
                      </Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#">
                        Next
                      </Link>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dataTables_paginate">
          {alerts && alerts.length > 0 && (
            <Pagination
              className="pagination-bar"
              currentPage={page}
              totalCount={alerts?.length}
              pageSize={PageSize}
              onPageChange={(page) => setPage(page)}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default Inbox;
